import { useRef, useState } from 'react';
import './Compress.css';
import backgroundVideo from '../assets/video/compress.mp4';
import { useNavigate } from 'react-router-dom';

export default function Compress() {
    const [type, setType] = useState('video');
    const [file, setFile] = useState(null);
    const [dragActive, setDragActive] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const inputRef = useRef(null);

    const handleFile = (e) => {
        if (e.target.files.length) {
            setFile(e.target.files[0]);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();

        const droppedFile = e.dataTransfer.files[0];

        if (droppedFile) {
            setFile(droppedFile);
        }

        setDragActive(false);
    };

    const handleSubmit = () => {
        navigate('/file/3');
    };

    const compress = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    setLoading(true);

    try {
        const response = await fetch("http://api.easy-compress.ru/compress", {
            method: "POST",
            body: formData
        });

        if (!response.ok) {
            throw new Error("Ошибка сжатия");
            setLoading(false);
        }

        const data = await response.json();

        console.log(data);

        // позже перейдём на страницу результата
        navigate(`/file/${data.id}`);
        setLoading(false);
    } catch (err) {
        console.error(err);
        alert("Не удалось загрузить файл");
        setLoading(false);
    }
};

    return (
        <section className="compress" id="compress">

            <video className="compress__video" autoPlay muted loop playsInline>
                <source src={backgroundVideo} type="video/mp4" />
            </video>

            <div className="compress__overlay"></div>

            <div className="compress__content">

                <h2 className="compress__title">
                    Загрузите файл
                </h2>

                <div className="compress__switch">
                    <button
                        className={`compress__switch-button ${type === 'video' ? 'compress__switch-button_active' : ''}`}
                        onClick={() => setType('video')}
                    >
                        Видео
                    </button>

                    <button
                        className={`compress__switch-button ${type === 'audio' ? 'compress__switch-button_active' : ''}`}
                        onClick={() => setType('audio')}
                    >
                        Аудио
                    </button>
                </div>

                <div
                    className={`compress__dropzone ${dragActive ? 'compress__dropzone_active' : ''}`}
                    onClick={() => inputRef.current.click()}
                    onDragEnter={() => setDragActive(true)}
                    onDragLeave={() => setDragActive(false)}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={handleDrop}
                >
                    <input
                        ref={inputRef}
                        type="file"
                        accept={type === 'video' ? 'video/*' : 'audio/*'}
                        hidden
                        onChange={handleFile}
                    />

                    <p className="compress__text">
                        {file
                            ? file.name
                            : `Нажмите или перетащите ${type === 'video' ? 'видео' : 'аудио'}`
                        }
                    </p>

                    <span className="compress__formats">
                        {type === 'video'
                            ? 'MP4 • MOV • AVI • MKV • WEBM • FLV • WMV • MPEG • M4V'
                            : 'MP3 • WAV • FLAC • AAC • OGG • M4A • OPUS'}
                    </span>
                </div>

                <button className={`compress__button ${file ? 'compress__button_visible' : ''}`} onClick={compress}>
                    {!loading ? 'Сжать' : 'Сжимаем'}
                </button>

            </div>

        </section>
    );
}
